// will deprecate soon
export const fourDpGrid = {
  none: 0,
  1: '0.25rem',
  2: '0.5rem',
  3: '0.75rem',
  4: '1.0625rem',
  5: '1.25rem',
  6: '1.5rem',
  7: '1.75rem',
  8: '2rem',
  9: '2.25rem',
  10: '2.5rem',
  16: '4rem',
  32: '8rem',
  64: '16rem',
  128: '32rem',
  256: '64rem',
}

// based off 4px increments
export const sizing = {
  0: 0,
  0.5: '0.125rem',
  1: '0.25rem',
  2: '0.5rem',
  3: '0.75rem',
  4: '1.0625rem',
  5: '1.25rem',
  6: '1.5rem',
  7: '1.75rem',
  8: '2rem',
  9: '2.25rem',
  10: '2.5rem',
  11: '2.75rem',
  12: '3rem',
  14: '3.5rem',
  15: '3.75rem',
  16: '4rem',
  18: '4.5rem',
  20: '5rem',
  24: '6rem',
  25: '6.25rem',
  30: '7.5rem',
  32: '8rem',
  38: '9.5rem',
  40: '10rem',
  48: '12rem',
  50: '12.5rem',
  64: '16rem',
  80: '20rem',
  95: '23.75rem',
  128: '32rem',
  256: '64rem',
}

export const paragraphSpacing = {
  xxs: sizing[0.5],
  xs: sizing[1],
  sm: sizing[2],
  md: sizing[4],
  lg: sizing[6],
  xl: sizing[8],
  xxl: sizing[10],
}

export const radius = {
  sm: sizing[1],
  md: sizing[2],
  lg: sizing[6],
}

export const borderWidth = {
  sm: '1px',
  md: sizing[0.5],
  lg: sizing[1],
}

export const iconSize = {
  xs: sizing[2],
  sm: sizing[4],
  md: sizing[8],
  lg: sizing[8],
  xl: sizing[12],
}
